
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Oral_glucose_tolerance_test",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/Oral_glucose_tolerance_test.vue